
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'index',
    //   component: function (resolve) {
    //     require(['@/components/index'], resolve)
    //   }
    // },
    // {
    //   path: '/search/:keyword?',
    //   name: 'search',
    //   component: function (resolve) {
    //     require(['@/components/search'], resolve)
    //   }
    // },
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: function (resolve) {
    //     require(['@/components/home'], resolve)
    //   }
    // },
    // {
    //   path: '/my/:tid?/:name?',
    //   name: 'myData',
    //   component: function (resolve) {
    //     require(['@/components/myData'], resolve)
    //   }
    // },
    // {
    //   path: '/teacher/:tid/:name?',
    //   name: 'teacher',
    //   component: function (resolve) {
    //     require(['@/components/myData'], resolve)
    //   }
    // },
    // {
    //   path: '/detail/:tid',
    //   name: 'detail',
    //   component: function (resolve) {
    //     require(['@/components/detail'], resolve)
    //   }
    // },
    // {
    //   path: '/share/:tid',
    //   name: 'shareDp',
    //   component: function (resolve) {
    //     require(['@/components/shareDp'], resolve)
    //   }
    // },
    // {
    //   path: '/comment/:tid',
    //   name: 'comment',
    //   component: function (resolve) {
    //     require(['@/components/comment'], resolve)
    //   }
    // },
    // {
    //   path: '/dianp/:tid',
    //   name: 'dianp',
    //   component: function (resolve) {
    //     require(['@/components/dianp'], resolve)
    //   }
    // },
    // {
    //   path: '/setting/:status?',
    //   name: 'setting',
    //   component: function (resolve) {
    //     require(['@/components/setting'], resolve)
    //   }
    // },
    {
      path: '/',
      name: 'game',
      component: function (resolve) {
        require(['@/components/gameList'], resolve)
      }
    },
    {
      path: '/game/:id',
      name: 'gameOne',
      component: function (resolve) {
        require(['@/components/gameOne'], resolve)
      }
    },
    {
      path: '/game/',
      name: 'gameList',
      component: function (resolve) {
        require(['@/components/gameList'], resolve)
      }
    },
    {
      path: '/gameshare/:info',
      name: 'gameShare',
      component: function (resolve) {
        require(['@/components/gameShare'], resolve)
      }
    },
    {
      path: '/result/:id',
      name: 'result',
      component: function (resolve) {
        require(['@/components/result'], resolve)
      }
    },
    // {
    //   path: '/cnews/:banji',
    //   name: 'classNews',
    //   component: function (resolve) {
    //     require(['@/components/classNews'], resolve)
    //   }
    // },
    // {
    //   path: '/cnews_dp/:banji/:tid',
    //   name: 'classDp',
    //   component: function (resolve) {
    //     require(['@/components/classDp'], resolve)
    //   }
    // },
    // {
    //   path: '/class/:banji',
    //   name: 'class',
    //   component: function (resolve) {
    //     require(['@/components/class'], resolve)
    //   }
    // },
    // {
    //   path: '/*',
    //   name: 'error',
    //   component: function (resolve) {
    //     require(['@/components/error'], resolve)
    //   }
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js